'use client'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { FreeMode } from 'swiper/modules'
import { useMediaQuery } from '~/hooks/use-media-query'
import './style.css'
import { Image } from '~/components/ui/image'
import { getImageUrl } from '~/utils/url-image'

export function HotelList({ list }) {
  const isDesktop = useMediaQuery('(min-width: 768px)')

  const getBreakpoints = () => {
    const totalHotels = list.length
    return {
      320: {
        slidesPerView: Math.min(2, totalHotels),
        spaceBetween: 8,
      },
      375: {
        slidesPerView: Math.min(2.5, totalHotels),
        spaceBetween: 12,
      },
      480: {
        slidesPerView: Math.min(3, totalHotels),
        spaceBetween: 16,
      },
      640: {
        slidesPerView: Math.min(3.5, totalHotels),
        spaceBetween: 16,
      },
    }
  }

  const renderHotelLogo = (hotel, index) => {
    return (
      <div key={index} className="flex w-[90px] flex-col items-center md:w-[138px]">
        <div className="mb-3">
          <Image
            src={getImageUrl(hotel.logo, 138, 80)}
            className="h-auto w-[90px] transform opacity-60 transition-opacity hover:scale-110 hover:opacity-100 sm:w-[90px] md:w-[138px]"
            alt={`${hotel?.name} logo`}
            aspectRatio={'1/1'}
            objectFit={'contain'}
          />
        </div>
      </div>
    )
  }

  return (
    // <div className="mb-8 w-full">
    //   <div className="py-0">
    <>
      {!isDesktop ? (
        <Swiper modules={[FreeMode]} className="swiper-hotel-list" breakpoints={getBreakpoints()}>
          {list.map((hotel, index) => (
            <SwiperSlide key={index}>{renderHotelLogo(hotel, index)}</SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className="flex justify-around gap-4">
          {list.map((hotel, index) => renderHotelLogo(hotel, index))}
        </div>
      )}
      {/* </div>
    </div> */}
    </>
  )
}
